import { Component } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-why-choose-us',
  templateUrl: './why-choose-us.component.html',
  styleUrl: './why-choose-us.component.scss'
})
export class WhyChooseUsComponent {
  constructor() { }

  ngOnInit(): void {
    // Set background images
    if ($("[data-bg-src]").length > 0) {
      $("[data-bg-src]").each(function () {
        const src = $(this).attr("data-bg-src");
        $(this).css("background-image", "url(" + src + ")");
        $(this).removeAttr("data-bg-src").addClass("background-image");
      });
    }
  }
}
